let lockPatent = [
	{
		path: '/lockPatent',
		name: 'lockPatent',
		component: ()=> import('@/views/lockPatent/lockPatent'),
		meta: {
			name: '标源_标源商标交易查询',
			breadCrumbName: '锁定记录'
		}
	}
]
export default lockPatent;